<template>
  <wa-modal-frame
    :is-showing="isShowing"
    @close-modal="closeModal"
  >
    <div 
      slot="content"
      style="padding:56.25% 0 0 0; position:relative;"
    >
      <iframe
        :src="videoUrl"
        frameborder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute; top:0; left:0; width:100%; height:100%;">
      </iframe>
    </div>
  </wa-modal-frame>
</template>

<script>
  import { ModalFrameMixin } from 'app/components-wa/modals/ModalFrame'
  import { v7PreSaleStatus } from 'app/views/plans/PlansData'

  export default {
    name: 'ModalV7Livestream',

    mixins: [ModalFrameMixin],

    props: {
      isShowing: {
        type: Boolean,
        default: true
      }
    },

    computed: {
      videoUrl() {
        if (v7PreSaleStatus.livestreamActive) {
          return "https://vimeo.com/event/4997977/embed/4e5ef9f4e2?autoplay=true"
        }

        return "https://player.vimeo.com/video/1067400288?autoplay=true"
      }
    },

    methods: {
      closeModal() {
        this.$emit('close-modal')
      }
    }
  }
</script>
